/** Sample import files — download from Group Configuration (EGMs + Import Mapping). */

function csvEscape(val) {
  const s = String(val ?? '')
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`
  return s
}

export function downloadTextFile(filename, content, mimeType = 'text/plain;charset=utf-8') {
  const blob = new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

const MACHINE_MASTER_ROWS = [
  ['010001', 'SERIAL00001', '0.01', 'SAMPLE GAME TITLE A'],
  ['010002', 'SERIAL00002', '0.01', 'SAMPLE GAME TITLE B'],
  ['010003', 'SERIAL00003', '0.01', 'SAMPLE GAME TITLE C'],
]

/** Machine master list for Group Config → EGMs tab (Excel-friendly CSV with column headers). */
export function downloadMachineMasterTemplate() {
  const lines = [
    '# Machine master list — save as .xlsx in Excel if you prefer. Header row is skipped on import.',
    '# Columns: house_number (5-6 digits), serial_number, denom (e.g. 0.01), game_name',
    'house_number,serial_number,denom,game_name',
    ...MACHINE_MASTER_ROWS.map((row) => row.map(csvEscape).join(',')),
    '',
  ]
  downloadTextFile('machine_master_list_template.csv', `\uFEFF${lines.join('\n')}`, 'text/csv;charset=utf-8')
}

/** Ready-to-import sample (no header row). */
export function downloadMachineMasterSample() {
  const lines = MACHINE_MASTER_ROWS.map((row) => row.map(csvEscape).join(','))
  downloadTextFile('machine_master_list_sample.csv', `\uFEFF${lines.join('\n')}\n`, 'text/csv;charset=utf-8')
}

const PIPE_SAMPLES = {
  meter: {
    filename: 'DimMeter_sample.txt',
    comment: '# RXConnect Meter_* — 15 cols: 7=MtrMoneyIn→CashIn, 8=MtrInTickets→TicketsIn, 9=unused, 10=cash_drop.',
    line: '1001|2026-03-10 04:15:00.000|218000000|209000000|0|0|1900000|77000000|140000|0|0|M|Yes|Sample Venue|Sample Venue',
  },
  sessions: {
    filename: 'FactPlayerSession_sample.txt',
    comment: '# Pipe-delimited sessions extract — no header. Import Mapping → Sessions.',
    line: '100001|010001|Sample Venue|SV|100|2026-03-10 00:00:00.000|2026-03-10 00:00:00.000|2026-03-10 10:00:00.000|2026-03-10 10:30:00.000|.0000|34.0000|100.0000|.0000|14.0000|33.00|134.0000|50|200|2.5000|2000|1|0|.0000|.0000|.0000|Sample Venue|Sample Venue|Yes|0|0',
  },
  patron: {
    filename: 'DimPatron_sample.txt',
    comment: '# Pipe-delimited DimPatron — no header. Import Mapping → Patron.',
    line: '1000|1001|1980-01-15|Financial|ORDINARY|Sample City|1000001001|JOHN SAMPLE|1980-01-15 00:00:00.000|January|2010-06-01 00:00:00.000|Active|Active|Australia|NSW|2000|SAMPLE CITY|SAMPLE ST|1 SAMPLE ST|member@example.com|0400000000|100.0000||M|Sample Venue|SV|100|1|SiteGroup|Sample Venue|Sample Venue',
  },
  egm: {
    filename: 'DimMachine_sample.txt',
    comment: '# Pipe-delimited DimMachine (65 cols) — no header. Import Mapping → EGM Registry.',
    line: '100001|2024-01-01 00:00:00.000|2024-06-01 00:00:00.000|01|01|01|010001|Aristocrat||SERIALABC01|SAMPLE GAME TITLE|iBoard|Active|EGM|.0100|400|10.00|90.00|GAMEID|N|.00|Y|0|N|Y|1|.0000|10.00|XSeries|Y|Y|1.0000|0|B|EGM|Sample Venue|SV|100|1|SiteGroup|1.AA001|01|Main Area||Sample Venue||On||||||||||||||||Sample Venue|Sample Venue',
  },
  slot_analysis: {
    filename: 'FactSlotAnalysisDaily_sample.txt',
    comment: '# Pipe-delimited FactSlotAnalysisDaily — 33 cols, no header. Import Mapping → Slot analysis.',
    line: '2026-03-10|1001|5000.00|4900.00|0.00|500|1200.00|3000.00|5000.00|3800.00|0.00|0.00|1200.00|0.00|8|2500.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|0.00|Yes|Sample Venue|Sample Venue|0.00|0.00|0.00|0.00|0.00|0.00',
  },
  visitor: {
    filename: 'DimVisitor_sample.txt',
    comment: '# Pipe-delimited DimVisitor — 13 cols, no header. Matches Sample Visitor (pipe) template.',
    line: '4176|2026-03-10 14:30:00.000|M-001234|Jane|Doe|1990-07-22|jane.doe@example.com|0412345678|Member|30c7e82f-3277-40e2-a692-00ed850b4b08|Sample Venue|SV|100',
  },
  tito: {
    filename: 'TITO-sample.csv',
    comment: '# System 7000 TITO CSV — header row, amounts in dollars. RedeemedAt NULL means not redeemed.',
    line: 'DateTime,TicketID,CreatedAt,Amount,RedeemedAt\n2026-10-19T10:04:55.207,6742031792404285,020387,10.00,NULL\n2026-10-19T10:05:07.683,6742031792404285,020387,10.00,020390',
  },
}

/** Sample pipe-delimited file for Import Mapping import types. */
export function downloadImportMappingSample(importType) {
  const sample = PIPE_SAMPLES[importType]
  if (!sample) return
  const body = `${sample.comment}\n${sample.line}\n`
  downloadTextFile(sample.filename, body)
}

export function importMappingSampleLabel(importType) {
  const labels = {
    meter: 'Meter format sample (.txt)',
    sessions: 'Sessions format sample (.txt)',
    patron: 'DimPatron format sample (.txt)',
    egm: 'DimMachine format sample (.txt)',
    slot_analysis: 'Slot analysis format sample (.txt)',
    visitor: 'Visitor format sample (.txt)',
    tito: 'TITO format sample (.csv)',
  }
  return labels[importType] || 'Format sample (.txt)'
}
